module.exports = __webpack_public_path__ + "static/media/icon-leaderboard.fcb073ae.svg";